import { gql } from 'graphql-request';

export const DOCUMENTS_FIELDS = gql`
  fragment DocumentsFields on DocumentDto {
    documentId
    name
    url
    category
    taskId
    delegateOrganizationId
    projectId
    project {
      projectId
      name
    }
    task {
      taskId
      name
      projectId
      project {
        projectId
        name
      }
    }
  }
`;

export const getDocuments = gql`
  query getDocuments(
    $projectIds: [String!]
    $taskIds: [String!]
    $name: String
    $category: String
    $page: Int
    $limit: Int
  ) {
    getDocuments(
      projectIds: $projectIds
      taskIds: $taskIds
      name: $name
      category: $category
      page: $page
      limit: $limit
    ) {
      documents {
        ...DocumentsFields
      }
      pagination {
        total
        page
        limit
        totalPages
        hasNext
        hasPrev
      }
    }
  }

  ${DOCUMENTS_FIELDS}
`;

export const addDocument = gql`
  mutation addDocument($document: DocumentCreateInput!) {
    addDocument(document: $document) {
      ...DocumentsFields
    }
  }
  ${DOCUMENTS_FIELDS}
`;

export const updateDocument = gql`
  mutation UpdateDocument($document: DocumentUpdateInput!) {
    updateDocument(document: $document) {
      ...DocumentsFields
    }
  }
  ${DOCUMENTS_FIELDS}
`;

export const deleteDocument = gql`
  mutation deleteDocument($id: String!) {
    deleteDocument(id: $id) {
      affected
      messages
    }
  }
`;

const DocumentsGraphQL = {
  queries: {
    getDocuments,
  },
  mutations: {
    addDocument,
    updateDocument,
    deleteDocument,
  },
};

export default DocumentsGraphQL;
